module.exports = __webpack_public_path__ + "static/media/projects.3b0bc9fa.png";